module.exports = __webpack_public_path__ + "img/PL08907.ee61d9de.png";